import RestClient from './RestClient';
import { Payment } from '../../models';

import _ from 'lodash';

class Payments extends RestClient {
    constructor() {
        super({
            model: Payment,
            entryPoint: 'payment',
            resource:   'payment',
            resources:  'payments',
            sortBy: 'payment_date'
        });
        this.ASK_PATH = '/ask';
    }

    ask(account_id, filters) {
        if (!account_id)
            throw new Error("Missing account id");

        // Drop empty filters and omit account_id: multi-select filters send it as an
        // array and must not overwrite the scalar account_id required by /payment/ask.
        filters = _.omit(_.pickBy((filters || {}), _.identity), 'account_id');
        return this.POST('/payment/ask', {
            ...filters,
            account_id,
        }).then(response => response.json())
          .then(json => {
              if (json[this.resource]) {
                  json[this.resource] = new this.model(json[this.resource]);
                  return json;
              }
              throw new Error(json.flash.error);
          });
    }

    fixBalances(account_id) {
        return this.POST('/payment/fix_balances', { account_id })
            .then(async response => {
                const json = await response.json();
                if (response.status !== 200) {
                    throw new Error(json.flash?.error?.msg);
                }
                return json;
            });
    }
}

const PaymentsApi = new Payments();

export default PaymentsApi;
